export const menuTestIDs = {
  mainMenu: 'main_menu',
  showMainMenu: 'main_menu_handle',
  search: 'search_menu_button',
  live: 'live_menu_button',
  onDemand: 'ondemand_menu_button',
  myWeather: 'myweather_menu_button',
  settings: 'settings_menu_button',
  dvr: 'dvr_menu_button',
  account: 'account_menu_button',
  debug: 'menu_test_debug_items',
  debugPanel: 'debug_panel',
  xfinityLogo: 'xfinity_logo',
};
